import React, { useEffect, useState } from 'react';
import cn from "classnames";
import style from "./index.module.scss";
import UncheckCircleIcon from '../../shared/icons/UncheckCircleIcon';
import ArrowUpIcon from '../../shared/icons/ArrowUpIcon';
import CustomButton from '../../custom/custom-button/CustomButton';
import ArrowDownIconNew from '../../shared/icons/ArrowDownIconNew';
import CheckVerifiedIcon from '../../shared/icons/CheckVerifiedIcon';
import UploadCloudIcon from '../../shared/icons/UploadCloudIcon';
import CloseIcon from '../../shared/icons/CloseIcon';
import DocumentNewIcon from '../../shared/icons/DocumentNewIcon';
import DeleteNewIcon from '../../shared/icons/DocumentNewIcon';
import { toast } from 'react-toastify';
import { File, User } from '../../../services';
import { useAmplitude } from '../../../hooks/useAmplitude';
import ClockLightIcon from '../../shared/icons/ClockLightIcon';
import { setUserData } from '../../../store/actions/userAction';
import { useDispatch } from 'react-redux';
import EditIconNew from '../../shared/icons/EditIconNew';
import Loading from '../../shared/Loading/Loading';
import {t} from "i18next";

const formatDocumentType = (contentType) => {
    const mimeMap = {
        'application/pdf': 'pdf',
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'image/webp': 'webp',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx'
    };

    return mimeMap[contentType] || contentType.split('/')[1];
};

const ConfirmDocuments = ({
    user,
    setIsOpenEmail,
    isOpenDocuments,
    setIsOpenDocuments,
    setIsOpenInstruction
}) => {
    const { amplitude } = useAmplitude();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState({});

    const [listDoc, setListDoc] = useState([]);
    const [uploadFirstFile, setUploadFirstFile] = useState(null);
    const [uploadSecondFile, setUploadSecondFile] = useState(null);
    const [currentDocumentId, setCurrentDocumentId] = useState(null);
    const [dragOver, setDragOver] = useState(false);

    const [isOpenModalFirst, setIsOpenModalFirst] = useState(false);
    const [isOpenModalSecond, setIsOpenModalSecond] = useState(false);
    const [showButtonTypeZero, setShowButtonTypeZero] = useState(true);
    const [showButtonTypeTwo, setShowButtonTypeTwo] = useState(true);

    const toggleLowerCard = () => {
        setIsOpenDocuments(!isOpenDocuments);
        setIsOpenEmail(false);
        setIsOpenInstruction(false);
    };

    const handleClose = (type) => {
        if (type === 0) {
            setIsOpenModalFirst(false);
        } else if (type === 2) {
            setIsOpenModalSecond(false);
        }
    }

    const handleSaveFile = (file, type) => {
        if (!file || isLoading) {
            toast.error("Загрузите файл или подождите, пока файл загружается");
            return;
        }

        if (currentDocumentId) {
            handleDeleteDocument(currentDocumentId);
        }

        amplitude.sendDocsToVerify();

        setIsLoading(true);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type);
        formData.append("userId", user.id);

        File.add(formData)
            .then(response => {
                if (response && response.status === 200) {
                    toast.success("Файл успешно загружен!");
                    handleClose(type);
                    updateUserData();
                    getDocList();
                } else {
                    if (type === 0) {
                        setUploadFirstFile(null);
                    } else if(type === 2) {
                        setUploadSecondFile(null);
                    }
                    toast.error("При загрузке файла произошла ошибка, попробуйте заново загрузить!");
                }
            })
            .catch(error => {
                requestErrorDisplay(error, "При загрузке файла произошла ошибка, попробуйте заново загрузить!");
                setIsLoading(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleDeleteDocument = async (documentId) => {
        setIsLoadingDelete(prevState => ({ ...prevState, [documentId]: true }));

        try {
            await File.deleteDocument(documentId);
            setIsLoadingDelete(false);
            getDocList();
        } catch (error) {
            console.error("Ошибка при удалении документа:", error);
            toast.error("Ошибка при удалении документа");
            setIsLoadingDelete(false);
        } finally {
            setIsLoadingDelete(prevState => ({ ...prevState, [documentId]: false }));
        }
    };

    const updateUserData = () => {
        User.get()
            .then(response => {
                console.log("[App]", response)
                dispatch(setUserData(response.data));
            })
            .catch(error => {
                console.log(error)
            });
    }

    const getDocList = () => {
        if (user && user.id) {
            File.getDocList(user.id)
                .then((response) => {
                    setListDoc(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            console.log("Невозможно проверить документы: ID пользователя не определен")
            setListDoc([]);
        }
    }

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragOver(true);
    }

    const handleDragLeave = () => {
        setDragOver(false);
    }

    /////////////////////////////////////////////

    const handleFileChangeFirst = (event) => {
        const file = event.target.files[0];
        if (file) {
            setUploadFirstFile(file);
            handleSaveFile(file, 0);
        }
    };

    const handleDropFirst = (event) => {
        event.preventDefault();
        setDragOver(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            setUploadFirstFile(file);
            handleSaveFile(file, 0);
        }
    };

    const handleDeleteFileFirst = () => {
        setUploadFirstFile(null);
    };

    /* *********************************** */

    const handleFileChangeSecond = (event) => {
        const file = event.target.files[0];
        if (file) {
            setUploadSecondFile(file);
            handleSaveFile(file, 2)
        }
    };

    const handleDropSecond = (event) => {
        event.preventDefault();
        setDragOver(false);
        const file = event.dataTransfer.files[0];
        if (file) {
            setUploadSecondFile(file);
            handleSaveFile(file, 2)
        }
    };

    const handleDeleteFileSecond = () => {
        setUploadSecondFile(null);
    };

    //////////////////////////////////////////////

    const formatFileSize = (size) => {
        if (size < 1024) return size + ' bytes';
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    const handleUpload = (type, documentId) => {
        if (documentId) {
            setCurrentDocumentId(documentId);
        }

        if (type === 0) {
            setIsOpenModalFirst(true);
        } else if (type === 2) {
            setIsOpenModalSecond(true);
        }
    }
    
    useEffect(() => {
        getDocList();
    }, []);

    useEffect(() => {
        const hasTypeZero = listDoc.some(doc => doc.type === 0);
        const hasTypeTwo = listDoc.some(doc => doc.type === 2);
        setShowButtonTypeZero(hasTypeZero);
        setShowButtonTypeTwo(hasTypeTwo);
    }, [listDoc]);

    return (
        <>
            <div className={cn(style.card, { [style.isBg]: isOpenDocuments })}>
                <div className={style.card_upper}>
                    <div className={style.card_head} onClick={toggleLowerCard}>
                        {listDoc.length <= 1 ? (
                            <UncheckCircleIcon />
                        ) : user.state === "Confirmed" ? (
                            <CheckVerifiedIcon width={24} height={24} />
                        ) : listDoc.length >= 2 ? (
                            <ClockLightIcon />
                        ) : null}
                        <div className={style.card_title}>{t('onboarding.documents.title')}</div>
                        {isOpenDocuments ? (
                            <ArrowUpIcon style={{ cursor: "pointer" }} />
                        ) : (
                            <ArrowDownIconNew style={{ cursor: "pointer" }} />
                        )}
                    </div>

                    <div className={style.card_text}>
                        {listDoc.length <= 1 ? (
                            `${t('onboarding.documents.confirmText')} ${!showButtonTypeZero ? t('tooDocument') : ''
                            }${!showButtonTypeZero && !showButtonTypeTwo ? ' ' + t('onboarding.documents.and') + ' ' : ''
                            }${!showButtonTypeTwo ? t('appointmentOrder') : ''}`
                        ) : user.state === "Confirmed" ? (
                            t('onboarding.documents.verifiedText')
                        ) : listDoc.length >= 2 ? (
                            t('onboarding.documents.moderationText')
                        ) : (
                            ''
                        )}
                    </div>
                </div>

                {(showButtonTypeZero !== showButtonTypeTwo) && (
                    <div className={cn(style.card_lower, { [style.isDisplay]: isOpenDocuments })}>
                        {!showButtonTypeZero && (
                            <div
                                className={cn(style.drop_box, { [style.dragOver]: dragOver })}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDropFirst}
                            >
                                <div className={style.drop_icon}>
                                    <UploadCloudIcon style={{ color: "#FA1861" }} />
                                </div>
                                <div className={style.drop_content}>
                                    <span className={style.drop_title}>{t('tooDocument')}</span>
                                    <div className={cn(style.drop_textUpload)}>
                                        <label className={style.drop_uploadFile}>
                                            <input type="file" onChange={handleFileChangeFirst} style={{ display: "none" }} />
                                            <span>{t('uploadFiles')}</span>
                                        </label>
                                        <span className={style.drop_boxText}>
                                            {t('dragDocsHere')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {!showButtonTypeTwo && (
                            <div
                                className={cn(style.drop_box, { [style.dragOver]: dragOver })}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDropSecond}
                            >
                                <div className={style.drop_icon}>
                                    <UploadCloudIcon style={{ color: "#FA1861" }} />
                                </div>
                                <div className={style.drop_content}>
                                    <span className={style.drop_title}>{t('appointmentOrder')}</span>
                                    <div className={cn(style.drop_textUpload)}>
                                        <label className={style.drop_uploadFile}>
                                            <input type="file" onChange={handleFileChangeSecond} style={{ display: "none" }} />
                                            <span>{t('uploadFiles')}</span>
                                        </label>
                                        <span className={style.drop_boxText}>
                                            {t('dragDocsHere')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className={cn(style.card_lower, { [style.isDisplay]: !isOpenDocuments })}>
                    {!showButtonTypeZero && (
                        <div
                            className={cn(style.drop_box, { [style.dragOver]: dragOver })}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDropFirst}
                        >
                            <div className={style.drop_icon}>
                                <UploadCloudIcon style={{ color: "#FA1861" }} />
                            </div>
                            <div className={style.drop_content}>
                                <span className={style.drop_title}>{t('tooDocument')}</span>
                                <div className={cn(style.drop_textUpload)}>
                                    <label className={style.drop_uploadFile}>
                                        <input type="file" onChange={handleFileChangeFirst} style={{ display: "none" }} />
                                        <span>{t('uploadFiles')}</span>
                                    </label>
                                    <span className={style.drop_boxText}>
                                        {t('dragDocsHere')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                    {!showButtonTypeTwo && (
                        <div
                            className={cn(style.drop_box, { [style.dragOver]: dragOver })}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDropSecond}
                        >
                            <div className={style.drop_icon}>
                                <UploadCloudIcon style={{ color: "#FA1861" }} />
                            </div>
                            <div className={style.drop_content}>
                                <span className={style.drop_title}>{t('appointmentOrder')}</span>
                                <div className={cn(style.drop_textUpload)}>
                                    <label className={style.drop_uploadFile}>
                                        <input type="file" onChange={handleFileChangeSecond} style={{ display: "none" }} />
                                        <span>{t('uploadFiles')}</span>
                                    </label>
                                    <span className={style.drop_boxText}>
                                        {t('dragDocsHere')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}

                    {listDoc.length === 0 ? null : (
                        <div className={cn(style.modal_fails, { [style.modal_hide]: listDoc.length === 0 })}>
                            {listDoc.map((doc, index) => (
                                <div key={index} className={style.fileItem}>
                                    <div className={style.fileItem_icon}>
                                        <DocumentNewIcon />
                                    </div>
                                    <div className={style.fileItem_content}>
                                        <div className={style.fileItem_name}>
                                            {doc.type === 0 ? t('tooDocument') : doc.type === 2 ? t('appointmentOrder') : t('doc')}
                                            .{formatDocumentType(doc.contentType)}
                                        </div>
                                        <div className={style.fileItem_size}>
                                            200 kb・{t('uploaded')}
                                        </div>
                                    </div>

                                    {user.state !== "Confirmed" && (
                                        <>
                                            <EditIconNew width={24} height={24} onClick={() => handleUpload(doc.type, doc.id)} />
                                            {isLoadingDelete[doc.id] ? (
                                                <Loading inBlock marginBottom={0} />
                                            ) : (
                                                <DeleteNewIcon onClick={() => handleDeleteDocument(doc.id)} />
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {isOpenModalFirst && (
                <div className={cn("modal-overlay", style.modal)}>
                    <div className={cn(style.modal_content)}>
                        <div className={style.modal_text}>
                            <div className={style.modal_title}>
                                {t('onboarding.documents.uploadTitleFirst')}<CloseIcon fill={'#6D7885'} onClick={() => handleClose(0)} />
                            </div>
                        </div>
                        <div
                            className={cn(style.modal_box, { [style.dragOver]: dragOver })}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDropFirst}
                        >
                            <div className={style.modal_icon}>
                                <UploadCloudIcon style={{ color: "#FA1861" }} />
                            </div>
                            <label className={style.modal_uploadFile}>
                                <input type="file" onChange={handleFileChangeFirst} style={{ display: "none" }} />
                                <div>{t('uploadFiles')}</div>
                            </label>
                            <div className={style.modal_boxText}>{t('dragDocsHere')}</div>
                        </div>

                        {uploadFirstFile && (
                            <div className={style.fileItem}>
                                <div className={style.fileItem_icon}>
                                    <DocumentNewIcon />
                                </div>
                                <div className={style.fileItem_content}>
                                    <div className={style.fileItem_name}>{uploadFirstFile.name}</div>
                                    <div className={style.fileItem_size}>
                                        {formatFileSize(uploadFirstFile.size)}・{t('uploaded')}
                                    </div>
                                </div>
                                <DeleteNewIcon onClick={handleDeleteFileFirst} />
                            </div>
                        )}
                        <CustomButton isFall text={t('save')} isLoading={isLoading} onClick={() => handleSaveFile(uploadFirstFile, 0)} />
                    </div>
                </div>
            )}

            {isOpenModalSecond && (
                <div className={cn("modal-overlay", style.modal)}>
                    <div className={cn(style.modal_content)}>
                        <div className={style.modal_text}>
                            <div className={style.modal_title}>
                                {t('onboarding.documents.appointment')}<CloseIcon fill={'#6D7885'} onClick={() => handleClose(2)} />
                            </div>
                        </div>
                        <div
                            className={cn(style.modal_box, { [style.dragOver]: dragOver })}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDropSecond}
                        >
                            <div className={style.modal_icon}>
                                <UploadCloudIcon style={{ color: "#FA1861" }} />
                            </div>
                            <label className={style.modal_uploadFile}>
                                <input type="file" onChange={handleFileChangeSecond} style={{ display: "none" }} />
                                <div>{t('uploadFiles')}</div>
                            </label>
                            <div className={style.modal_boxText}>{t('dragDocsHere')}</div>
                        </div>

                        {uploadSecondFile && (
                            <div className={style.fileItem}>
                                <div className={style.fileItem_icon}>
                                    <DocumentNewIcon />
                                </div>
                                <div className={style.fileItem_content}>
                                    <div className={style.fileItem_name}>{uploadSecondFile.name}</div>
                                    <div className={style.fileItem_size}>
                                        {formatFileSize(uploadSecondFile.size)}・{t('uploaded')}
                                    </div>
                                </div>
                                <DeleteNewIcon onClick={handleDeleteFileSecond} />
                            </div>
                        )}
                        <CustomButton isFall text={t('save')} isLoading={isLoading} onClick={() => handleSaveFile(uploadSecondFile, 2)} />
                    </div>
                </div>
            )}
        </>
    );
}

export default ConfirmDocuments;
